import ReactMarkdown from 'react-markdown'
import type { MessagesWithAds } from '../chat'
import NormalAds from './NormalAds'
import { DownloadIcon, TypingLoader } from '@/assets/icons'

interface MessageListProps {
  messages: MessagesWithAds[]
  messagesEndRef: React.RefObject<HTMLDivElement | null>
  isTyping: boolean
}

const MessageList = ({
  messages,
  messagesEndRef,
  isTyping,
}: MessageListProps) => {
  return (
    <div className='flex-1 overflow-y-auto px-4 py-6 space-y-4'>
      {messages.map(msg => {
        const pdfLink = msg?.pdfLink

        const fileName = pdfLink
          ? pdfLink.split('/').pop()?.replace('.pdf', '')
          : ''

        const formattedName = fileName
          ? fileName.charAt(0).toUpperCase() + fileName.slice(1)
          : ''

        return (
          <div key={msg?.timestamp} className='space-y-2 w-full'>
            {msg.userQuery && (
              <div className='flex justify-end w-full'>
                <div className='bg-[#DEE2E6] text-[#444444] font-normal text-[14px] leading-[116%] px-5 py-4 rounded-[12px] rounded-br-none shadow-[0_1px_1px_0_#00000033] max-w-[80%] whitespace-pre-wrap break-words'>
                  {msg.userQuery}
                </div>
              </div>
            )}
            {msg.response && !msg.resImg && (
              <div className='flex justify-start w-full'>
                <div className='px-5 py-[15px] bg-black text-white font-normal text-[14px] leading-[116%] rounded-[12px] rounded-bl-none max-w-[80%] whitespace-pre-wrap break-words'>
                  {pdfLink ? (
                    <div>
                      <p>{msg.response}</p>
                      <br />
                      <p>{formattedName}</p>
                      <a
                        href={pdfLink}
                        download
                        className='mt-2 inline-flex items-center gap-2 px-3 py-2 bg-white text-black text-sm font-medium rounded-lg shadow-sm hover:bg-gray-100 transition'
                      >
                        <DownloadIcon className='w-4 h-4' />
                        Download
                      </a>
                    </div>
                  ) : (
                    <ReactMarkdown>{msg.response}</ReactMarkdown>
                  )}
                </div>
              </div>
            )}

            {msg.resImg && (
              <div className='flex justify-start w-full'>
                <img
                  src={msg.resImg}
                  alt={msg.company_name ?? 'ad_image'}
                  className='max-w-[80%] rounded-[12px] shadow-md'
                />
              </div>
            )}
            {msg.type === 'ads' && msg.category_name !== 'Premium' && (
              <NormalAds msg={msg} />
            )}
          </div>
        )
      })}
      {isTyping && (
        <div className='w-[34px]'>
          <TypingLoader />
        </div>
      )}
      <div ref={messagesEndRef} />
    </div>
  )
}

export default MessageList
